import React, { useState, useEffect, useContext } from 'react';
import { isValidPassword } from '../../services/UtilService';
import { dbPost } from '../../apis/commonApi';
import {
  useGlobalStore,
  GlobalContext,
  ModalContext,
} from '../../components/contexts';
import { useNavigate } from 'react-router-dom';
import { set } from 'react-hook-form';

const ChangePassword = () => {
  useEffect(() => {
    document.title = '비밀번호 변경';
  }, []);
  const { store, updateStore } = useGlobalStore();
  const { modalService } = useContext(ModalContext);
  const [pswdValid, setPswdValid] = useState(null);
  const [pswdCompare, setPswdCompare] = useState(null);
  const [pswdValidMsg, setPswdValidMsg] = useState('');

  const [formData, setFormData] = useState({
    userPswd: '',
    newPswd: '',
    newPswdCnfrm: '',
  });

  useEffect(() => {
    if (store) {
      setFormData(prevFormData => ({
        ...prevFormData,
        userId: store.userId || '',
        userSn: store.userSn || '',
      }));
    }
  }, [store]);

  // 아이디 비밀번호 입력 input 스페이스 금지
  const handleKeyDown = e => {
    if (e.key === ' ') {
      e.preventDefault();
    }
  };

  // 아이디 비밀번호 입력 input 붙여넣기 금지
  const handlePaste = e => {
    e.preventDefault();
  };

  // 입력값 state에 저장
  const handleInputChange = e => {
    const { id, value } = e.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [id]: value,
    }));
  };

  const navigate = useNavigate();

  // 비밀번호 유효성 검사 useEffect
  useEffect(() => {
    if (
      pswdCompare == true &&
      formData.newPswd != '' &&
      formData.newPswdCnfrm != '' &&
      formData.newPswd.length >= 8 &&
      formData.newPswdCnfrm.length >= 8
    ) {
      validatePassword();
    } else if (pswdCompare == false) {
      setPswdValidMsg('비밀번호가 일치하지 않습니다.');
      setPswdValid(false);
    }
  }, [pswdCompare]);

  // 비밀번호와 비밀번호 확인 필드 비교
  useEffect(() => {
    setPswdCompare(formData.newPswd === formData.newPswdCnfrm ? true : false);
  }, [formData.newPswd, formData.newPswdCnfrm]);

  const validatePassword = () => {
    const result = isValidPassword(formData.newPswd); // utilService에서 가져온 함수 호출

    if (result) {
      setPswdValidMsg(result); // 에러 메시지를 설정
      setPswdValid(false); // 유효하지 않은 경우 처리
    } else {
      setPswdValidMsg('사용 가능한 비밀번호입니다.'); // 유효한 경우 메시지
      setPswdValid(true); // 유효한 경우 처리
    }
  };

  const chgPswd = async () => {
    const url = '/member/userInfo/chgPassword.do';
    const param = {
      userSn: formData.userSn,
      userPswd: formData.userPswd,
      newPswd: formData.newPswd,
    };
    if (pswdValid == true && pswdCompare == true) {
      dbPost(url, param)
        .then(response => {
          if (response.code === 1) {
            modalService.successAlert(response.message, () => {
              fnLogout();
            });
          } else if (response.code === 2) {
            modalService.errorAlert(response.message, () => {});
          } else if (response.code === 3) {
            modalService.errorAlert(response.message, () => {});
          }
        })
        .catch(error => {});
    }
  };

  const fnLogout = async () => {
    try {
      const token = sessionStorage.getItem('token');
      if (token) {
        await doLogout(token); // 로그아웃 API 호출
      }
    } catch (e) {}

    sessionStorage.removeItem('token');

    updateStore('authrtId', 'NU');
    updateStore('menuList', []);
    updateStore('logined', false);
    updateStore('userType', '');
    updateStore('entSn', '');
    updateStore('userSn', '');
    updateStore('userId', '');
    updateStore('userNm', '');
    updateStore('selectedFirstDepthMenu', '');

    let menuList = [];

    try {
      menuList = await getAuthrtMenu('NU');
      updateStore('menuList', menuList);
      setHeaderMenu(menuList.filter(menu => menu.level === 0));
    } catch (error) {}

    sessionStorage.removeItem('remainingTime');
    sessionStorage.clear();

    navigate('/');
  };

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">비밀번호 변경</h2>
      </div>

      <h3 className="content-tit">비밀번호 변경</h3>
      <p className="text-gray-70">비밀번호를 변경하실 수 있습니다.</p>
      <p className="tbl-msg gap-sm">
        <em className="star-require">*</em> 표시는 필수 입력 사항입니다.
      </p>
      <div className="txt-box bg-white">
        <fieldset>
          <legend>비밀번호 변경</legend>
          <div className="fieldset">
            <div className="form-group">
              <div className="form-title">
                <label htmlFor="userPswd">
                  현재 비밀번호<em className="star-require">*</em>
                </label>
              </div>
              <div className="form-conts">
                <input
                  type="password"
                  id="userPswd"
                  className="form-control"
                  value={formData.userPswd || ''}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown} // 비밀번호 스페이스바 금지
                  onPaste={handlePaste} // 비밀번호 붙여넣기 금지
                  maxLength={20}
                />
              </div>
            </div>

            <div className="form-group">
              <div className="form-title">
                <label htmlFor="newPswd">
                  새 비밀번호<em className="star-require">*</em>
                </label>
              </div>
              <div className="form-conts">
                <input
                  type="password"
                  id="newPswd"
                  className="form-control"
                  value={formData.newPswd || ''}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown} // 비밀번호 스페이스바 금지
                  onPaste={handlePaste} // 비밀번호 붙여넣기 금지
                  maxLength={20}
                />
                <p></p>
              </div>
            </div>

            <div className="form-group">
              <div className="form-title">
                <label htmlFor="newPswdCnfrm">
                  새 비밀번호 확인<em className="star-require">*</em>
                </label>
              </div>
              <div className="form-conts">
                <input
                  type="password"
                  id="newPswdCnfrm"
                  className="form-control"
                  value={formData.newPswdCnfrm || ''}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown} // 비밀번호 스페이스바 금지
                  onPaste={handlePaste} // 비밀번호 붙여넣기 금지
                  maxLength={20}
                />
                {pswdValid !== null ? (
                  <p
                    className={
                      pswdCompare == true && pswdValid == true
                        ? 'text-secondary'
                        : 'text-point'
                    }
                  >
                    {pswdValidMsg}
                  </p>
                ) : null}
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <div className="page-btn-wrap">
        <button
          type="button"
          className="btn xlg primary"
          onClick={() => {
            chgPswd();
          }}
        >
          비밀번호 변경
        </button>
      </div>
    </>
  );
};

export default ChangePassword;
